import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getActionReasons,
  getBrandOfSelectedTicket,
  getDecisionNodeAtPath,
  getRbiCustomerId,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../../../extractFromState';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { AVAILABLE_FIELDS_CONFIG, DTSelectActionReasonView } from '../../DTSelectActionReasonView';
import SelectInputReason from '../../Common/SelectInputReason/SelectInputReason';
import { getRbiExistingSupportCouponsCount } from '../../../../../../selectors/tools';
import { getRemediationReasons } from '../../../../../../api/orders/rbi';
import { setLoadingUnique } from '../../../../../../actions';
import { handleError } from '../../../../../../services/ErrorService/ErrorService';

const DTSelectRbiRefundAndCouponReasonNode = () => {
  const dispatch = useDispatch();

  const actionReasons = useSelector(getActionReasons);
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const brandName = useSelector(getBrandOfSelectedTicket);
  const customerId = useSelector(getRbiCustomerId);
  const rbiExistingSupportCouponsCount = useSelector(getRbiExistingSupportCouponsCount);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (decisionNode.maxCouponsLinit && rbiExistingSupportCouponsCount >= parseInt(decisionNode.maxCouponsLinit)) {
      dispatch(addEdgeToDecisionTreePath('max_coupons_limit_exceeded'));
    }
    (async () => {
      try {
        dispatch(setLoadingUnique(true, 'reasonContainer'));
        const reasons = await getRemediationReasons({ simplrAccountId, brandName, customerId });
        if (Array.isArray(reasons)) {
          setOptions(reasons);
        }
      } catch (error) {
        handleError({ error, showPopup: true });
      } finally {
        dispatch(setLoadingUnique(false, 'reasonContainer'));
      }
    })();
  }, [dispatch, rbiExistingSupportCouponsCount, decisionNode, simplrAccountId, brandName, customerId]);

  const handleNextButtonClick = () => dispatch(addEdgeToDecisionTreePath('reason_selected'));

  return (
    <DTSelectActionReasonView
      isNextButtonActive={actionReasons?.refundPrimaryReason && actionReasons?.couponPrimaryReason}
      onNextButtonClick={handleNextButtonClick}
    >
      <SelectInputReason
        placeholder="Select refund reason"
        options={options}
        fields={AVAILABLE_FIELDS_CONFIG.refundReason}
      />
      <SelectInputReason
        placeholder="Select coupon reason"
        options={options}
        fields={AVAILABLE_FIELDS_CONFIG.couponReason}
      />
    </DTSelectActionReasonView>
  );
};

export default DTSelectRbiRefundAndCouponReasonNode;
